(() => {
  const pending = new WeakSet();
  const inputFor = (form) => Array.from(document.querySelectorAll('[data-shipping-ack-input]')).find((input) => input.form === form);
  const showError = (input, kind) => {
    const error = input.closest('[data-shipping-ack]').querySelector('[data-shipping-ack-error]');
    error.textContent = kind === 'save' ? error.dataset.saveMessage : error.dataset.requiredMessage;
    error.hidden = false;
    input.setAttribute('aria-invalid', 'true');
    input.focus();
  };
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-shipping-ack-input]')) return;
    event.target.removeAttribute('aria-invalid');
    event.target.closest('[data-shipping-ack]').querySelector('[data-shipping-ack-error]').hidden = true;
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[name="checkout"], input[name="checkout"]');
    const input = button && button.form && inputFor(button.form);
    if (input && !input.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(input, 'required');
    }
  }, true);
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const input = inputFor(form);
    if (!input) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!input.checked) {
      showError(input, 'required');
      return;
    }
    if (pending.has(form)) return;
    pending.add(form);
    const button = event.submitter;
    if (button) button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(window.routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Shipping acknowledgment': input.value } })
      });
      if (!response.ok) throw new Error('Acknowledgment could not be saved');
      const cart = await response.json();
      if (cart.attributes?.['Shipping acknowledgment'] !== input.value) throw new Error('Acknowledgment was not saved');
      if (!input.checked || !input.isConnected) {
        if (input.isConnected) showError(input, 'required');
        return;
      }
      const checkout = document.createElement('input');
      checkout.type = 'hidden';
      checkout.name = 'checkout';
      checkout.value = 'Checkout';
      form.appendChild(checkout);
      HTMLFormElement.prototype.submit.call(form);
    } catch {
      showError(input, 'save');
    } finally {
      pending.delete(form);
      form.removeAttribute('aria-busy');
      if (button) button.disabled = false;
    }
  }, true);
})();
